export default {
    AttemptLimitExceeded: 'pages.account.verification.too.many.requests',
    IncorrectOTP: 'pages.account.verification.incorrect.otp',
    'Invalid session for the user.': 'pages.forgotcredentials.expired.code.exception',
    UnexpectedErrorOccured: 'general.unexpectedErrorOccurred',
};
